import { z } from "zod";

// Input Form Validation Schema
export const passwordValidationSchema = z
  .object({
    password: z
      .string()
      .min(13, {
        message: "Invalid Input. Must be at least 13 Characters long",
      })
      .refine(
        (password) => {
          // Add your custom password validation logic here
          // Return true if validation passes, false otherwise
          return (
            /[A-Z]/.test(password) && // At least one uppercase letter
            /[0-9]/.test(password) && // At least one digit
            /[!@#$%^&*(),.?":{}|<>\/\\]/.test(password) && // At least one special character
            /^.{13,}$/.test(password)
          );
        },
        { message: "Invalid password format" },
      ),
    password_confirmation: z.string().min(13, { message: "Invalid format." }),
  })
  .refine((data) => data.password === data.password_confirmation, {
    message: "Passwords don't match",
    path: ["password_confirmation"],
  });
